import React from 'react';
export var DragHandleDisabledIcon = function DragHandleDisabledIcon(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "16",
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style,
    "data-testid": "drag-icon-disabled"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "16",
    rx: "4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "7",
    y: "4",
    width: "2",
    height: "8",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "11",
    y: "4",
    width: "2",
    height: "8",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "15",
    y: "4",
    width: "2",
    height: "8",
    rx: "1"
  })));
};